/**
 * Contrat du namespace WebSocket `/session`.
 *
 * Le serveur émet, le client écoute — il n'y a volontairement aucun événement client → serveur
 * autre que l'adhésion à la salle : tout ce qui modifie l'état passe par HTTP, ce qui garde une
 * seule porte d'entrée à valider et à autoriser.
 */
export const SESSION_NAMESPACE = '/session';
export const SESSION_EVENTS = {
    /** L'admin ouvre les notes : les membres peuvent saisir (session PLANNED → OPEN). */
    TASTING_OPENED: 'tasting:opened',
    /** Un rhum à l'aveugle est dévoilé — tous les écrans basculent en même temps (US-15). */
    RUM_REVEALED: 'rum:revealed',
    /** La séance est close : les notes sont gelées et le récap est disponible (US-16). */
    SESSION_CLOSED: 'session:closed',
    /** Compteur d'avancement, pour « 4 / 5 ont validé » sans faire de polling. */
    PROGRESS_CHANGED: 'session:progress',
};
/** Nom de la salle socket.io d'une séance. Utilisé des deux côtés, donc partagé. */
export function sessionRoom(sessionId) {
    return `session:${sessionId}`;
}
//# sourceMappingURL=events.js.map